<template>
  <div class="empty-component" :class="{ 'is-mobile': isMobile() }">
    <img class="ai-logo" src="../../assets/ai-logo-empty.png" />
    <!-- <img src="https://xbbprdpro.xbongbong.com.cn/xbbProPrd/ding0064986624e3b83b35c2f4657eb6378f/02276334205821146722/png/1754891788242a75ee236302b14634fda80c92288f1ae.png" class="ai-logo" /> -->
    <template v-if="$slots.text">
      <slot name="text"></slot>
    </template>
    <template v-else>
      <span>{{ emptyText }}</span>
    </template>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { isMobile } from '@/utils'

defineProps({
  emptyText: {
    type: String,
    default: '暂无数据'
  }
})

onMounted(() => {
  // Lifecycle hook
})
</script>

<style lang="scss" scoped>
.empty-component {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  span {
    margin-top: 16px;
    color: #969799;
  }
  .ai-logo {
    width: 170px;
    height: 113px;
  }
}
.is-mobile {
  height: unset;
  span {
    font-size: 14px;
  }
}
</style>
